import Vue from 'vue';

import bookshelfService from '@d-services/bookshelf-service/bookshelf-service';
import bookshelfElement from '@d-shared/blog/bookshelf-element';
import URLS from '@d-shared/urls/urls';
import { getErrorMessage } from '@d-shared/utils/errors';

export default class AddToLibraryButton {
  constructor(node, blogManager, options, isUserSignedIn, bookshelfEntries) {
    this.node = node;
    this.bookshelfOptions = options;
    this.blogManager = blogManager;
    this.isUserSignedIn = isUserSignedIn;
    this.bookshelfEntries = bookshelfEntries;

    this.bookshelfEntry = null;
    this.bookInfo = null;

    this.toggleBookshelvesContainer = this.toggleBookshelvesContainer.bind(this);
    this.openModal = this.openModal.bind(this);

    this.initialise();
  }

  async initialise() {
    this.bookInfo = {
      url: this.node.getAttribute('data-url'),
      slug: this.node.getAttribute('data-slug'),
    };

    if (this.isUserSignedIn) {
      this.bookshelfEntry = this.bookshelfEntries.find((entry) => entry.book.slug === this.bookInfo.slug);

      this.prepareButtonContent();
      this.node.addEventListener('click', this.toggleBookshelvesContainer);
    } else {
      this.node.addEventListener('click', this.openModal);
    }

    this.node.parentNode.classList.remove('hidden');
  }

  async openModal() {
    Vue.prototype.signupModal.show();
  }

  toggleBookshelvesContainer() {
    this.blogManager.activeButton === this ? this.closeBookshelvesContainer() : this.openBookshelvesContainer();
  }

  closeBookshelvesContainer() {
    this.blogManager.removeActiveButton();
    this.node.parentNode.classList.remove('open');
  }

  openBookshelvesContainer() {
    this.blogManager.changeActiveButton(this);
    this.node.parentNode.classList.add('open');
  }

  prepareButtonContent() {
    if (this.bookshelfEntry) {
      this.setCurrentBookshelf(this.bookshelfEntry.bookshelf);
    }

    const contentWrapper = document.createElement('div');
    contentWrapper.classList.add('content-container');
    const content = document.createElement('div');
    content.classList.add('content');
    const list = document.createElement('ul');
    list.classList.add('actions');

    this.generateOptions(list);

    content.appendChild(list);
    contentWrapper.appendChild(content);

    this.node.parentNode.appendChild(contentWrapper);
  }

  generateOptions(list) {
    this.bookshelfOptions.forEach((option) => {
      list.appendChild(bookshelfElement(
        option,
        this.bookshelfEntry && this.bookshelfEntry.bookshelf,
        this.selectBookshelf(option.value),
      ));
    });
  }

  updateBookshelvesContainer() {
    const list = this.node.parentNode.querySelector('.actions');
    list.innerHTML = '';

    this.generateOptions(list);
  }

  selectBookshelf(bookshelf) {
    return async () => {
      this.setSavingStatus();
      this.closeBookshelvesContainer();

      this.bookshelfEntry ? await this.changeBookshelf(bookshelf) : await this.addToLibrary(bookshelf);

      this.updateBookshelvesContainer();
    };
  }

  async addToLibrary(bookshelf) {
    const data = {
      bookshelf_entry: {
        bookshelf: bookshelf,
        book_url: this.bookInfo.url,
        skip_post: true,
      },
    };

    try {
      this.bookshelfEntry = await bookshelfService.addEntry(data);
      this.setCurrentBookshelf(bookshelf);
      Vue.duiNotificationManager.success('Book added to your bookshelf!', URLS.app.library.bookshelf);
    } catch (error) {
      Vue.duiNotificationManager.error(getErrorMessage(error));
    }
  };

  async changeBookshelf(bookshelf) {
    try {
      await bookshelfService.moveToBookshelf(this.bookshelfEntry.slug, bookshelf);
      this.setCurrentBookshelf(bookshelf);
      Vue.duiNotificationManager.success('Bookshelf updated!');
    } catch (error) {
      Vue.duiNotificationManager.error(getErrorMessage(error));
    }
  }

  setCurrentBookshelf(bookshelf) {
    this.bookshelfEntry.bookshelf = bookshelf;
    this.node.innerHTML = bookshelfService.getBookshelfOptionText(bookshelf);
    this.node.parentNode.removeAttribute('disabled');
  }

  setSavingStatus() {
    this.node.innerHTML = 'Saving...';
    this.node.parentNode.setAttribute('disabled', 'disabled');
  }
}
